module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor29-1539e7c6f9b9e487bd845fdf872a268e.jpg";